import { parseSafeInt } from "Backend";

export type PuidPlatform = "pat" | "collect" | "unknown";
type PuidSegment = "user" | "case";

function parsePuid(puid: string): {
  platform: PuidPlatform;
  segment: PuidSegment | "unknown";
  value?: string;
} {
  const parts = puid.split(":");

  return {
    platform: parts[0] === "pat" ? "pat" : parts[0] === "collect" ? "collect" : "unknown",
    segment: parts[1] === "user" ? "user" : parts[1] === "case" ? "case" : "unknown",
    value: parts[2],
  };
}

export function parsePuidAndPlatform(puid: string): {
  platform: PuidPlatform;
  value?: number | undefined;
} {
  const parsed = parsePuid(puid);
  const valueAsInt = parseSafeInt(parsed.value);
  return {
    platform: parsed.platform,
    value:
      (parsed.platform === "pat" || parsed.platform === "collect") && parsed.segment === "user"
        ? valueAsInt
        : undefined,
  };
}

export function parseAppUserPuid(puid: string): number | undefined {
  const parsed = parsePuid(puid);
  const value = parseSafeInt(parsed.value);

  return parsed.platform === "pat" && parsed.segment === "user" ? value : undefined;
}
